import { useRouter } from 'next/router';
import React from 'react';

import {
  DaysListing,
  Header,
  WorkerDailyDuesSummary,
} from '@/modules/workingDayReconciliation';
import { WorkingDayReconciliationProvider } from '@/modules/workingDayReconciliation/context/context';

export default function WorkingDayReconciliation() {
  // TODO: this shall be refactored when update design for crew level
  const { query } = useRouter();

  return (
    <WorkingDayReconciliationProvider>
      <div className='flex flex-col'>
        <Header />
        {query.type === 'worker' && <WorkerDailyDuesSummary />}
        {query.type === 'crew' && <DaysListing />}
      </div>
    </WorkingDayReconciliationProvider>
  );
}
